import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    $('.js-accountancy-commission-fee-updated').change(function() {
      return $(this).submit();
    });
  }
}
